var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Select2',{staticClass:"default-style",attrs:{"options":_vm.advertisersOptions,"placeholder":"Buscar anunciante","selectedOption":_vm.selectedAdvertiser,"filterable":false},on:{"input":_vm.selectAdvertiser,"search":_vm.searchAdvertisers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }